import { defineFcm } from '../shared/factory';

export const FCM_DM_WITH_LEGISLATIVE_BODIES_CONNECTION_ENABLED = defineFcm(
	'dm_with_legislative_bodies_connection_enabled',
)
	.asBoolean()
	.withDefault(false)
	.withMerger(({ globalValue, countryValue, localeValue }) => {
		if (countryValue || localeValue) return localeValue && countryValue;
		return globalValue;
	})
	.toConfig();
